<template>
  <div class="swiper-container swiper33" style="width:100%;height:500px;color:#ffffff">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="item in  img" :key="item.id">
        <div id="shadow" :style="{display:display}"></div>
        <div v-if="msg === '医院介绍'">
          <div id="swiperFont">
            <div>
              <div id="borderTop"></div>
              <div id="name">{{msg}}</div>
              <div id="borderBottom"></div>
            </div>
          </div>
          <div>
            <div id="swiperText">{{projectForm.introduction}}</div>
          </div>
          <div id="swiperDetail">
            <div id="top"></div>
            <div style="writing-mode: tb-rl;" @click="open">查看详情</div>
            <div id="bottom"></div>
          </div>
        </div>
        <img style="height:100%;width:100%" :src="item.fileUrl" alt/>
      </div>
    </div>
  </div>
</template>
<script>
  import Swiper from "swiper";
  import "../../node_modules/swiper/css/swiper.css";

  export default {
    props: {
      msg: String
    },
    data() {
      return {
        sectionList: JSON.parse(sessionStorage.getItem('sectionList')),
        projectForm: JSON.parse(sessionStorage.getItem('projectForm')),
        id: '',
        img: [],
        display: ''
      };
    },
    created() {
      for (let i = 0; i < this.sectionList.length; i++) {
        if (("/" + this.sectionList[i].url) === this.$route.path) {
          this.img = this.sectionList[i].fileList;
          this.id = this.sectionList[i].id
        }
      }
    },
    methods: {
      open() {
        this.$router.push({ name: "body" ,query:{id: this.id}});
      },
      banner(){
        if(this.$route.path != '/Survey'){
          this.display = 'none'
        }
      }
    },
    mounted() {
      this.banner();
      var mySwiper = new Swiper(".swiper33", {
        // slidesPerView: 2,
        centeredSlides: false,
        centeredSlidesBounds: true
      });
    }
  };
</script>
<style lang="less" scoped>
  #shadow {
    width: 100%;
    height: 100%;
    position: absolute;
    background: rgba(0, 0, 0, 0.2);
  }

  #swiperFont {
    position: absolute;
    right: 300px;
    top: 50px;
    #name {
      font-size: 32px;
      width: 40px;
      padding: 20px;
      text-align: center;
      position: absolute;
      top: 40px;
    }
    #borderTop {
      width: 80px;
      height: 100px;
      position: absolute;
      background-image: url(../assets/img/png3_03.png);
      background-size: 100% 100%;
    }
    #borderBottom {
      width: 80px;
      height: 100px;
      position: absolute;
      top: 180px;
      background-image: url(../assets/img/png4_03.png);
      background-size: 100% 100%;
    }
  }

  #swiperText {
    position: absolute;
    right: 350px;
    height: 80%;
    top: 40px;
    writing-mode: tb-rl;
  }

  #swiperDetail :hover {
    cursor: pointer;
  }

  #swiperDetail {
    position: absolute;
    right: 480px;
    top: 45px;
    font-size: 22px;
    padding: 10px;
    #top {
      width: 100%;
      height: 20px;
      margin-bottom: 10px;
      background-image: url(../assets/img/png1_03.png);
      background-size: 100% 100%;
    }
    #bottom {
      width: 100%;
      height: 20px;
      margin-top: 10px;
      background-image: url(../assets/img/png2_03.png);
      background-size: 100% 100%;
    }
  }
</style>
